import React, { useEffect } from 'react';

import { Image } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';
import { TelInput } from '../TelInput';
import { ErrorMessage } from '@hookform/error-message';
import { NavbarProps, SearchInputs } from '@models';
import { useRecoilState, useRecoilValue } from 'recoil';
import { companyUniqueId, companyId, isCompanyActive, showSearchExistingConsentBtn } from './companyUniqueId.atom';
import { CompanyService } from 'src/services';
import * as moment from 'moment';
import 'moment-timezone';

export function Navbar(props: NavbarProps): React.JSX.Element {
  const [showSearchModal, setSearchModalShow] = useState(false);
  const [showSearchResultModal, setSearchResultModalShow] = useState(false);
  const [showSearchNoResultModal, setSearchNoResultModalShow] = useState(false);
  const [searchMobileNumber, setSearchMobileNumber] = useState('');
  const [showAPIErrorModal, setShowAPIErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [company_active, setCompanyActive] = useRecoilState(isCompanyActive);

  const [searchResult, setSearchResult] = useState([]);
  const handleSearchModalClose = () => setSearchModalShow(false);
  const handleSearchModalShow = () => setSearchModalShow(true);

  const handleSearchResultModalShow = () => setSearchResultModalShow(true);
  const handleSearchResultModalClose = () => {
    setSearchResultModalShow(false);
    setSearchMobileNumber('');
  }

  const handleCloseAPIErrorModal = () => {
    setShowAPIErrorModal(false);
  }

  const handleSearchNoResultModalShow = () => setSearchNoResultModalShow(true);
  const handleSearchNoResultModalClose = () => {
    setSearchNoResultModalShow(false);
    setSearchMobileNumber('');
  }

  const company_id = useRecoilValue(companyId);
  const uniqueId = useRecoilValue(companyUniqueId);
  const showSearchBar = useRecoilValue(showSearchExistingConsentBtn);
  // const company_active = useRecoilValue(isCompanyActive);

  useEffect(() => {
    console.log("Unique ID Navbar", uniqueId);
    console.log("Company ID Navbar", company_id);
    console.log("Company Active Navbar", company_active);
  }, [uniqueId, company_id, company_active]);

  const {
    register,
    control,
    trigger,
    reset,
    handleSubmit,
    setError,
    setFocus,
    formState: { errors },
  } = useForm<SearchInputs>()
  const onSearchClick = async (formData: SearchInputs) => {
    console.log(formData)
    setSearchResult([]);

    CompanyService.searchConsents(uniqueId, { search: formData.mobileNumber })
      .then((response: any) => {
        console.log("Search Response", response);
        reset();
        if (response.data.list.length > 0) {
          let result = response.data.list;
          setSearchResult(result);
          setSearchMobileNumber(response.data.mobile_number);
          handleSearchResultModalShow();
        } else {
          handleSearchNoResultModalShow();
        }
        handleSearchModalClose();
        console.log(response)
      })
      .catch((error: any) => {
        if (error.response) {
          console.log(error.response.data);
          if (error.response.status === 401) {
            setCompanyActive(false);
          }
          if (error.response.data.message !== "") {
            handleSearchModalClose();
            setErrorMessage(error.response.data.message); setShowAPIErrorModal(true);
          }
        }
        console.log(error)
      })
  }
  return (
    <>
      <nav className="navbar navbar-light container-fluid  bg-light">
        <div className="container">
          <div className="navbar-brand w-100">
            <nav className="navbar navbar-expand-lg navbar-light">
              <div className="container-fluid pe-0">
                <a className="navbar-brand" href="javascript:void(0)"> <Image
                  src={props.tenantInfo?.company_logo || "/img/CallerConsent-Logo.svg"}
                  style={{ height: '50px' }}
                  alt="logo"
                /></a>

                <button className='mainbutton btn d-block d-sm-none mobilebutton' type="button" onClick={handleSearchModalShow}>Search for Existing Consent</button>
                {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" 
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button> */}
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                  </ul>
                  {showSearchBar &&
                    <div className='text-danger attention'>
                      <button className='mainbutton btn px-4' disabled={!company_active} type="button" onClick={handleSearchModalShow}>Search for Existing Consent</button>
                    </div>
                  }
                </div>
              </div>
            </nav>

          </div>
        </div>
      </nav>
      {/* modal Search for Existing Consent */}

      <Modal backdrop="static"
        keyboard={false} onHide={handleSearchModalClose} show={showSearchModal} >
        <Modal.Header closeButton>
          <Modal.Title> <h5>Search for Existing Consent</h5></Modal.Title>
        </Modal.Header>
        <form onSubmit={handleSubmit(onSearchClick)}>
          <Modal.Body>
            <div className='col-lg-12'>
              <div className='col-lg-12 mb-3'>
                <Form.Label htmlFor="inputPassword5" className='mb-1'>Please enter phone number of the caller*</Form.Label>

                <TelInput useFormMethods={
                  {
                    register,
                    control,
                    trigger
                  }
                } name="mobileNumber" required={true} schema={{
                  errorMessage: {
                    required: "Please enter phone number",
                    validate: 'Please enter a valid phone number.'
                  }
                }} ></TelInput>
                <ErrorMessage name="mobileNumber" errors={errors} render={({ message }) => <p className="error-message">{message}</p>} />

              </div>
            </div></Modal.Body>
          <Modal.Footer>
            <button className='mainbutton btn px-4' type="submit">Search</button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* modal existing consent */}
      <Modal backdrop="static"
        keyboard={false} onHide={handleSearchResultModalClose} show={showSearchResultModal}
        size="xl"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">
            Existing Consent Results for {searchMobileNumber}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>  <div className='col-lg-12 mb-3' style={{ overflowY: 'scroll', height: '70vh' }}>
          <h5 className="mb-3 " style={{ color: '#004aad!important' }}>Here is the existing consent for your company related to this caller/ mobile number</h5>
          {
            searchResult.map((item: any) => {
              return (
                <div className='border p-3 border-radius mb-3'>
                  <div className='row mb-2'>
                    <div className='col-lg-4'><small>Date Requested</small><br></br>
                      {moment.utc(item.created_at).tz("America/New_York").format("MM/DD/YYYY h:mm:ss A")} EDT</div>
                    <div className='col-lg-4'><small>Status</small><br></br>
                      <span dangerouslySetInnerHTML={{ __html: item.status }}></span>
                    </div>
                    <div className='col-lg-4'><small>Name</small><br></br>
                      {item.name}</div>
                  </div>
                  <div className='row mb-2'>
                    <div className='col-lg-4'><small>Mobile Number</small><br></br>
                      {item.formatted_phone_number}</div>
                    <div className='col-lg-4'><small>Requested By</small><br></br>
                      <span className='text-success'>
                        {
                          item.tcpa_ref_id.startsWith("REV-") ? "Company Attested" :
                            (item?.requested_by_company ?
                              (item?.requested_by_company?.id === company_id ?
                                item?.requested_by_company?.company_name : item?.requested_by_company?.company_name + " via Share")
                              : "Consumer Requested")}
                      </span></div>
                    <div className='col-lg-4'><small>Consent Language Used</small><br></br>
                      {item.consent_language.title}</div>
                  </div>
                  <div className='row mb-2'>
                    {(item.brand || item.beneficiary) ?
                      <>
                        <div className='col-lg-4'><small>Brand</small><br></br>
                          {item.brand}
                        </div>
                        <div className='col-lg-4'><small>Beneficiary</small><br></br>
                          {item?.beneficiary}
                        </div>
                      </>
                      : null}
                    <div className='col-lg-4'>
                      <small>InboundTCPA Reference Number</small><br></br>
                      {item.tcpa_ref_id}</div>

                    {item.consent_rejected_at ? <div className='col-lg-4' >
                      <small> Date of Revocation</small><br></br>
                      {moment.utc(item.consent_rejected_at).tz("America/New_York").format("MM/DD/YYYY h:mm:ss A")} EDT</div>
                      : ""}

                    {item.consent_approved_at ? <div className='col-lg-4' >
                      <small> Date of Opt-In</small><br></br>
                      {moment.utc(item.consent_approved_at).tz("America/New_York").format("MM/DD/YYYY h:mm:ss A")} EDT</div>
                      : ""}

                  </div>
                </div>


              );
            })
          }
        </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='col-lg-12 mt-3 text-center'>
            <button className='mainbutton btn px-4' onClick={handleSearchResultModalClose}>Close</button>
          </div>
        </Modal.Footer>
      </Modal>


      {/* modal Send Opt-In Request */}

      <Modal
        backdrop="static"
        keyboard={false}
        onHide={handleSearchNoResultModalClose}
        show={showSearchNoResultModal} >
        <Modal.Header closeButton>
          <Modal.Title> <h5>Search for Existing Consent</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='col-lg-12'>
            <div className='col-lg-12 mb-3 text-center'>
              <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M58.3333 29.1667V52.5C58.3333 58.9458 53.1125 64.1667 46.6666 64.1667H23.3333C17.4125 64.1667 12.5416 59.7917 11.7833 54.075C11.6958 53.55 11.6666 53.025 11.6666 52.5V17.5C11.6666 11.0542 16.8875 5.83334 23.3333 5.83334H35C35.7291 5.83334 36.4 6.09584 36.925 6.56251C36.9833 6.59168 37.0125 6.65001 37.0708 6.67918L50.4875 20.0958V20.125L57.4875 27.0958C57.5163 27.1542 57.575 27.1833 57.6041 27.2417C58.0708 27.7667 58.3333 28.4375 58.3333 29.1667Z" fill="#FF0308" />
                <path d="M58.3333 29.1667V32.0833H43.7499C37.3041 32.0833 32.0833 26.8625 32.0833 20.4167V5.83334H34.9999C35.7291 5.83334 36.3999 6.09584 36.9249 6.56251L50.4874 20.125L57.6041 27.2417C58.0708 27.7667 58.3333 28.4375 58.3333 29.1667Z" fill="#EA3326" />
                <path d="M39.1244 42.2917L41.4373 39.9788C42.5766 38.8395 42.5766 36.9938 41.4373 35.8543C40.2981 34.7148 38.4524 34.7151 37.3128 35.8543L34.9999 38.1672L32.687 35.8543C31.5478 34.7151 29.7021 34.7151 28.5626 35.8543C27.423 36.9936 27.4233 38.8392 28.5626 39.9788L30.8755 42.2917L28.5626 44.6046C27.4233 45.7438 27.4233 47.5895 28.5626 48.7291C29.1325 49.2984 29.8786 49.5833 30.6249 49.5833C31.3713 49.5833 32.1174 49.2984 32.687 48.7288L34.9999 46.4161L37.3128 48.7291C37.8825 49.2984 38.6286 49.5833 39.3749 49.5833C40.1213 49.5833 40.8674 49.2984 41.437 48.7288C42.5763 47.5895 42.5763 45.7438 41.437 44.6043L39.1244 42.2917Z" fill="white" />
                <path opacity="0.15" d="M58.3333 29.1667V52.5C58.3333 58.9458 53.1125 64.1667 46.6667 64.1667H23.3333C17.4125 64.1667 12.5417 59.7917 11.7833 54.075C18.1708 52.85 23.625 50.8667 28.2333 48.3875C34.0667 45.2375 38.5875 41.2417 42.0875 36.8083C43.2542 35.2917 44.3333 33.6875 45.2958 32.0833C47.6 28.2042 49.2917 24.15 50.4875 20.125L57.4875 27.0958C57.5164 27.1542 57.575 27.1833 57.6042 27.2417C58.0708 27.7667 58.3333 28.4375 58.3333 29.1667Z" fill="black" />
              </svg>
              <br></br>
              Sorry, there is no consent<br></br>
              associated to your company for this<br></br>
              caller / mobile number
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='col-lg-12 mt-3 text-center'>
            <button className='mainbutton btn px-4' onClick={handleSearchNoResultModalClose}>Close</button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal backdrop="static"
        keyboard={false} onHide={handleCloseAPIErrorModal} show={showAPIErrorModal} >
        <Modal.Header closeButton>
          <Modal.Title> <h5>Alert</h5></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='col-lg-12'>
            <h5>{errorMessage}</h5>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className='mainbutton btn px-4 mb-2' type='button' onClick={handleCloseAPIErrorModal}>Close</button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
